import React, { CSSProperties } from 'react'
import logo from './aputeam.png'
import './style.scss'

type Props = {
  imageUrl: string
  label?: React.ReactNode
  style?: CSSProperties
}

export const Logo = (props: Props) => {
  return (
    <div className="c-logo__wrapper" style={props.style || {}}>
      {/* <div className="c-logo__image" style={{ backgroundImage: `url(${window.origin + props.imageUrl}` }}>

      </div> */}

      <img src={logo} />
    </div>
  )
}

export default Logo
